module.exports = __webpack_public_path__ + "img/maritimeTrafficRegulations.0a60bf67.svg";